import { AuthErrorKind, AuthFlow, AuthFlowError } from '@griply/types';

import { getAuthErrorCode, mapAuthError } from './map-auth-error';

export type AuthErrorReport = {
  tags: Record<string, string>;
  fingerprint: string[];
  extra?: Record<string, unknown>;
};

export type CaptureAuthError = (
  error: unknown,
  report: AuthErrorReport,
) => void;

// Groups each unrecognised auth failure by the flow it happened in and the code it carried.
export const reportAuthFailure = (
  error: unknown,
  flow: AuthFlow,
  captureException: CaptureAuthError,
  extra?: Record<string, unknown>,
) => {
  const code = getAuthErrorCode(error) || 'no-code';
  captureException(error, {
    tags: { source: `auth-${flow}`, authCode: code },
    fingerprint: ['auth', flow, code],
    ...(extra && { extra }),
  });
};

// Only an unrecognised failure is ours to hear about; every other kind is an outcome the form shows.
export const toAuthFlowError = (
  error: unknown,
  flow: AuthFlow,
  captureException: CaptureAuthError,
  extra?: Record<string, unknown>,
): AuthFlowError => {
  const kind = mapAuthError(error);

  if (kind === AuthErrorKind.Unknown) {
    reportAuthFailure(error, flow, captureException, extra);
  }

  return new AuthFlowError(kind, { cause: error });
};
